import { Injectable } from '@angular/core';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { GridDataService } from '../../../../../../gk-kendo';
import { DevelopmentPlanDetailsGridDto } from './development-plan-details-grid-data-model';

@Injectable({
  providedIn: 'any',
})
export class DevelopmentPlanDetailsGridDataService extends GridDataService<DevelopmentPlanDetailsGridDto> {
  constructor() {
    super(
      '/api/mapa/planzagospodarowania/uchwalyplany/searchgeom',
      'POST',
      (data) =>
        orderBy(data, [{ field: 'NrUchwaly', dir: 'asc' }] as SortDescriptor[]),
    );
  }
}
